export default __webpack_public_path__ + "static/media/add-icon.f015c7aa.svg";